import React from 'react';
import { FourOhThree } from '@brighterion/br-ui';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';
import Layout from 'Components/Layout';

const ForbiddenPage: React.FC = () => {
    const { logout } = useAuthenticationStore.getState();

    return (
        <Layout>
            <FourOhThree tFunc={(str) => str} onLinkClick={logout} />
        </Layout>
    );
};

export default ForbiddenPage;
